import React, { lazy, Suspense, useEffect } from 'react';
import auth, { useWithUserAndTenant } from 'cp-client-auth!sofe';
import { recalculatePrimaryNavHeight } from './primary-nav-height.helpers.js';
import { recalculatePrimaryNavWidth } from './primary-nav-width.helpers.js';
import ErrorBoundary from 'canopy-react-error-boundary';

const ClientContainer = lazy(() =>
  import(/* webpackChunkName: "ClientContainer" */ './client-portal/client-portal.container.js')
);
const PractionerContainer = lazy(() =>
  import(/* webpackChunkName: "PractitionerContainer" */ './practitioner/practitioner.container.js')
);

export function RootComponent(props) {
  const [user, tenant] = useWithUserAndTenant();

  // keep track of user sessions and log them out when their sessions expire
  useEffect(() => auth.trackSession(), [])

  useEffect(() => {
    if (user && tenant) {
      recalculatePrimaryNavHeight(user, tenant);
      recalculatePrimaryNavWidth();
    }
  }, [user, tenant]);

  if (user && tenant) {
    return <ClientOrPractitioner user={user} tenant={tenant} />;
  } else {
    return null;
  }
}

export function ClientOrPractitioner(props) {
  const { user, tenant } = props;

  if (user.effective_permissions.client) {
    return <LoadClientContainer {...props} />;
  } else {
    return <LoadPractitionerContainer {...props} />;
  }
}

export function LoadClientContainer(props) {
  return (
    <Suspense fallback={null}>
      <ClientContainer {...props} />
    </Suspense>
  );
}

export function LoadPractitionerContainer(props) {
  return (
    <Suspense fallback={null}>
      <PractionerContainer {...props} />
    </Suspense>  );
}

export default ErrorBoundary({ featureName: 'Primary navbar' })(RootComponent);
